"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.volumeFlowConversions = volumeFlowConversions;
exports.massFlowConversions = massFlowConversions;
const calculations_1 = require("@munters/calculations");
function volumeFlowConversions(fromAmount, to, conversionParameters) {
    if (conversionParameters.density === undefined &&
        (conversionParameters.humidityRatio === undefined ||
            conversionParameters.temperature === undefined ||
            conversionParameters.pressure === undefined)) {
        throw new Error("Required conversion parameters for massFlowConversions is undefined");
    }
    const useDensity = conversionParameters.density !== undefined;
    switch (to) {
        case "MassFlow": {
            if (useDensity) {
                return calculations_1.Physics.FlowConversion.volumeFlowToMassFlowUsingDensity(conversionParameters.density, fromAmount);
            }
            return calculations_1.Physics.FlowConversion.volumeFlowToMassFlow(conversionParameters.temperature, conversionParameters.humidityRatio, conversionParameters.pressure, fromAmount);
        }
        default: {
            throw new Error(`Can't convert ${fromAmount.unit.quantity} to ${to}`);
        }
    }
}
function massFlowConversions(fromAmount, to, conversionParameters) {
    if (conversionParameters.density === undefined &&
        (conversionParameters.humidityRatio === undefined ||
            conversionParameters.temperature === undefined ||
            conversionParameters.pressure === undefined)) {
        throw new Error("Required conversion parameters for massFlowConversions is undefined");
    }
    const useDensity = conversionParameters.density !== undefined;
    switch (to) {
        case "VolumeFlow": {
            if (useDensity) {
                return calculations_1.Physics.FlowConversion.massFlowToVolumeFlowUsingDensity(conversionParameters.density, fromAmount);
            }
            return calculations_1.Physics.FlowConversion.massFlowToVolumeFlow(conversionParameters.temperature, conversionParameters.humidityRatio, conversionParameters.pressure, fromAmount);
        }
        default: {
            throw new Error(`Can't convert ${fromAmount.unit.quantity} to ${to}`);
        }
    }
}
//# sourceMappingURL=flow-conversions.js.map